<template>
  <div>
    <div v-show="flag">
      <bill v-if="type=='order'" :orderObj="printobj" ref="billPrintS"></bill>

      <billa v-if="type=='bill'" :orderObj="printobj" ref="billPrintObj"></billa>
      <sockPrint v-if="type=='menu'" :orderObj="orderObjs" ref='sockPrint'> </sockPrint>



    </div>

  </div>

</template>

<script>
  import sockPrint from './sockPrint.vue'
  import billa from './billprint'
  import bill from '../dashboard/components/bill.vue'
  import axios from 'axios'

  export default {
    components: {
      bill,
      sockPrint,
      billa
    },
    data() {
      return {
        printPosCode: '',
        PDatas: "",
        orderObjs: {},
        printobj: {},
        printorders: false,
        printerPosCodeObj: "",
        client: null,
        posCodeFlag: false,
        flag: false,
        type: ""
      }

    },

    created() {
      let code = localStorage.getItem('hotelCode')
      if (code) {
        console.log(1);
        this.printPosCodes()
        this.printorders = true
      }

      if(localStorage.getItem('token')) {
        this.mainPrinterPosCodes()
      }


    },
    mounted() {
      this.$bus.$on('mq2', val => {
        if (val) {
          this.printPosCodes()
          this.mainPrinterPosCodes()
          this.printorders = true
        }
      })
      this.$bus.$on('logout', val => {
        if (val) {
          this.logout() //退出接受消息
        }
      })
      document.addEventListener('visibilitychange', () => {

        // 用户离开了当前页面
        if (document.visibilityState === 'hidden') {
          // document.title = '页面不可见';
          console.log('页面不可见');
        }

        // 用户打开或回到页面
        if (document.visibilityState === 'visible') {
          // document.title = '页面可见';
          console.log('页面可见');
          this.logout()
          this.mq()
        }
      });
    },
    methods: {

      printPosCodes() {
        console.log('调用printPosCodes----------------')
        let code = localStorage.getItem('hotelCode')
        let url = this.api.printPosCode + '?hotelCode=' + code
        let methods = 'get'

        // axios.get(url).then(e => {
        //     console.log(e.data,'e--------------------data')
        //    if (e.data.status == 0) {
        //     this.printPosCode = e.data.data.printPosCode
        //     console.log('printPosCode22', this.printPosCode);
        //     this.mq()
        //   }
        // })
        console.log(url,'url-------')
        console.count()
        this.$axios({
          url,
          methods
        })
        .then(e => {
          console.log(e,'rqwererq23-----------------wrq23');
          if (e?.data?.status == 0) {
            console.log(e.data,'e--------------------data')
            this.printPosCode = e.data.data.printPosCode
            console.log('printPosCode22', this.printPosCode);

            this.mq()


          }
        }).catch(err => {
          console.log('sock.vue第121行:::err', err);
        })
      },

      printOrder(value) {
        this.orderObjs = value

        this.$nextTick(() => {
          this.$refs.sockPrint.todoPrintS()
        })
      },

      bill(value) {
        this.printobj = value
        var num = 0,
          nums = 0

        value.orderMenus.map(res => {
          if (res.totalPrice) {
            res.total_price = res.totalPrice
          }
          num = num + res.total_price

        })

        if (value.bills && value.bills.length) {
          value.bills.map(ress => {
            nums = nums + ress.totalPrice * 1
          })
        }
        if (!value.titles) {
          this.printobj.alls_price = nums

        }
        this.printobj.total_price = num


        this.$nextTick(() => {
          console.log('账单打印');
          this.$refs.billPrintS.getPrint()

        })
      },
      billPrint(value) {
        this.printobj = value
        this.$nextTick(() => {
          console.log('预付打印');

          this.$refs.billPrintObj.getlist()

        })
      },
      mainPrinterPosCodes() {
        let code = localStorage.getItem('hotelCode')
        let url = this.api.mainPrinterPosCode + '?hotelCode=' + code
        let methods = 'get'

        axios.get(url).then(res => {
           if (res.data.status == 0) {
            this.printerPosCodeObj = res.data.data
          } else {
            this.$message({
              message: "获取账单打印机失败",
              type: "error"
            })

          }
        })

        // this.$axios({
        //   url,
        //   methods
        // }).then(res => {
        //   console.log(res,'169----scok')
        //   if (res.data.status == 0) {
        //     this.printerPosCodeObj = res.data.data
        //   } else {
        //     this.$message({
        //       message: "获取账单打印机失败",
        //       type: "error"
        //     })

        //   }

        // })

      },

      mq(val) {
        console.log(this.printPosCode,'posCode-----print')
        let posCode = localStorage.getItem('posCode')

        if (posCode !== this.printPosCode) {
          console.log('不是主控退出订阅');
          this.posCodeFlag = false
          return
        }
        this.posCodeFlag = true
        console.log('主控订阅');
        var Stomp = require('stompjs');
        //activeMQ一对一接收方式
        // var url = "ws://82.157.120.133:61614";
        var url = "ws://42.193.49.192:61614";
        var login = "rooibook";
        var passcode = "cjthis_999";

        //监听的队列
        //需要和发送者的发送的队列名称一致否则无法接受到数据
        // console.log('printPosCode', printPosCode);
        // var destination = '/topic/' + printPosCode;

        // var destination = '/queue/a9a4132f-c439-4239-a4a2-8c65558e33f5' ;
        this.client = Stomp.client(url);

        // var onconnect = (frame) => {


        // };

        this.client.connect(login, passcode, this.onConnected, this.onFailed);


      },
      onConnected(frame) {
        let posCode = localStorage.getItem('posCode')
        let printPosCode = this.printPosCode

        var destination = '/queue/' + printPosCode;
        var subscription = this.client.subscribe(destination, (message) => {
          let temp = {}
          let temps = {}
          let value = {}
          temp = JSON.parse(message.body)
          this.type = temp.type

          console.log(1, temp);
          temps = JSON.parse(temp.value)
          console.log(2, temps);
          value = JSON.parse(temps.data)
          console.log(3, value);
          let printName = ''
          //打印机名字  
          // 账单打印调用后台接口，菜品打印用接收到的数据

          if (temp.type == 'order' || temp.type == 'bill') {
            printName = this.printerPosCodeObj[0].name

            console.log('printName1------------',printName)

          } else {
            console.log('printName2------------',printName)
            
            if (value.hasOwnProperty("orderMenusMap")) {
              if (value.orderMenusMap[0].printname) {
                printName = value.orderMenusMap[0].printname
                console.log('printNameA',printName)
              } else if (value.orderMenusMap[0].printer) {
                printName = value.orderMenusMap[0].printer[0].kitchenPrinterName
                console.log('printNameB',printName)

              }
            } else if (value.orderMenus[0].printer) {
              printName = value.orderMenus[0].printer[0].kitchenPrinterName
                console.log('printNameC',printName)

            }
          }
          
          console.log("posCode:",posCode,'temp.toipcName:',temp.toipcName)
          if (posCode == temp.toipcName) {

            this.$bus.$emit('printName', printName)

            //打印送菜
            if (temp.type == 'menu') {


              this.printOrder(value)
            }
            // return
            //打印账单
            if (temp.type == 'order') {


              this.bill(value)
            }

            if (temp.type == 'bill') {

              this.billPrint(value)
            }

          }

        });

      },
      onFailed: function (frame) {
        console.log('Failed: ' + frame)
      },
      //退出接受消息
      logout() {

        if (this.posCodeFlag) {
          this.client.disconnect();
          this.client = null;
          console.log('执行退出接受消息任务', this);
        }



      }

    }
  }
</script>

<style>
</style>